import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMeetingNotes from '../../reducers/meeting-notes/meeting-notes.reducer';

export const selectMeetingNotesState = createFeatureSelector<fromMeetingNotes.State>(
  fromMeetingNotes.meetingNotesFeatureKey
);

export const selectMeetingNotes = createSelector(
  selectMeetingNotesState,
  (state) => state.notes
);

export const selectMeetingNotesLoading = createSelector(
  selectMeetingNotesState,
  (state) => state.loading
);

export const selectMeetingNotesUploading = createSelector(
  selectMeetingNotesState,
  (state) => state.uploading
);

export const selectMeetingNotesDeleting = createSelector(
  selectMeetingNotesState,
  (state) => state.deleting
);

export const selectMeetingNotesViewing = createSelector(
  selectMeetingNotesState,
  (state) => state.viewing
);

export const selectUploadModalOpen = createSelector(
  selectMeetingNotesState,
  (state) => state.uploadModalOpen
);

export const selectMeetingNotesError = createSelector(
  selectMeetingNotesState,
  (state) => state.error
);
